import { debounce } from "lodash"
import React, { useMemo } from "react"

type OwnProps = {
    onInputChange: (inputValue) => void
    debounceTimeout?: number
    className?: string
    placeholder?: string
    onTypingStatusChange?: (isTyping: boolean) => void
}

const DebouncedInput = (props: OwnProps) => {

    const handleInputChange = (newValue: string) => {
        props.onInputChange(newValue)
        handleTypingStatusChange(false)
    }

    const debouncedChangeHandler = useMemo(() => {
        return debounce(handleInputChange, props.debounceTimeout || 1000)
    }, [])
    
    const handleTypingStatusChange = (typingStatus: boolean) => {
        if(props.onTypingStatusChange){
            props.onTypingStatusChange(typingStatus)
        }
    }
    
    return (
        <div>
            <input
                type="text" 
                onChange={(e) => {
                    handleTypingStatusChange(true)
                    debouncedChangeHandler(e.target.value)
                }}
                {...props}
            />
        </div>
    )
}

DebouncedInput.defaultProps = {
    debounceTimeout: 1000, // Default debounce timeout is 1000ms
}

export default DebouncedInput




// WEBPACK FOOTER //
// ./src/common/inputs/DebouncedInput.tsx